/**
 * Build a "click to chat" WhatsApp URL.
 * wa.me accepts digits only for the number segment.
 */
export function buildWhatsAppUrl(number, text) {
  const phone = (number || "").replace(/\D/g, "");
  const encoded = encodeURIComponent(text || "");
  return `https://wa.me/${phone}${encoded ? `?text=${encoded}` : ""}`;
}
